import React from "react";
import {
  CalendarWrapper,
  CalendarIconButton,
  RangeLabel,
  ClearButton,
} from "./Trigger.styles";
import IconComponent from "../IconComponent";

type CalendarTriggerProps = {
  darkMode?: boolean;
  rangeLabel: string;
  hasRange: boolean;
  onOpen: () => void;
  onClear?: () => void;
};

const CalendarTrigger: React.FC<CalendarTriggerProps> = ({
  darkMode = false,
  rangeLabel,
  hasRange,
  onOpen,
  onClear,
}) => {
  return (
    <CalendarWrapper $darkMode={darkMode} onClick={onOpen}>
      <CalendarIconButton type="button" aria-label="Open calendar">
        <IconComponent className="fa fa-calendar text-primary f-20" />
      </CalendarIconButton>

      <RangeLabel title={rangeLabel}>{rangeLabel}</RangeLabel>

      {hasRange && onClear && (
        <ClearButton
          className="text-primary"
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
        >
          Clear
        </ClearButton>
      )}
    </CalendarWrapper>
  );
};

export default CalendarTrigger;
